module.exports = __webpack_public_path__ + "img/horizontal_6_5_3016.7b742216.png";